import { createSvgIcon } from '@mui/material'

export const GenerateReggieNumber = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' width='34' height='25.248' viewBox='0 0 37 25.248'>
    <g id='Group_1161' data-name='Group 1161' transform='translate(-22 -239.999)'>
      <g id='Group_1160' data-name='Group 1160'>
        <g id='computer-employee-svgrepo-com' transform='translate(22 217.205)'>
          <path
            id='Path_534'
            data-name='Path 534'
            d='M23.076,139.691h-.645a.965.965,0,1,1,0-1.929h.645a1.128,1.128,0,0,0,1.127-1.127v-14.83a1.128,1.128,0,0,0-1.127-1.127H3.056a1.128,1.128,0,0,0-1.127,1.127v14.83a1.128,1.128,0,0,0,1.127,1.127H16.462a.965.965,0,1,1,0,1.929H3.056A3.059,3.059,0,0,1,0,136.635v-14.83a3.059,3.059,0,0,1,3.056-3.056h20.02a3.059,3.059,0,0,1,3.056,3.056v14.83A3.059,3.059,0,0,1,23.076,139.691Z'
            transform='translate(0 -95.956)'
            fill='#fff'
          />
          <rect
            id='Rectangle_608'
            data-name='Rectangle 608'
            width='6.792'
            height='4.307'
            transform='translate(9.67 42.771)'
            fill='none'
          />
          <g id='Group_1142' data-name='Group 1142' transform='translate(6.277 27.442)'>
            <path
              id='Path_535'
              data-name='Path 535'
              d='M140.568,415.051h-6.793a.965.965,0,0,1-.965-.965V409.78a.965.965,0,0,1,.965-.965h6.793a.965.965,0,0,1,.965.965v4.307A.964.964,0,0,1,140.568,415.051Zm-5.828-1.929H139.6v-2.378H134.74v2.378Z'
              transform='translate(-130.383 -394.45)'
              fill='#fff'
            />
            <path
              id='Path_536'
              data-name='Path 536'
              d='M108.382,476.456H96.734a.965.965,0,0,1,0-1.929h11.649a.965.965,0,0,1,0,1.929Z'
              transform='translate(-95.769 -455.855)'
              fill='#fff'
            />
            <path
              id='Path_539'
              data-name='Path 539'
              d='M124.034,195.183a2.765,2.765,0,1,1,2.765-2.765A2.768,2.768,0,0,1,124.034,195.183Zm0-4.488a1.723,1.723,0,1,0,1.723,1.723A1.725,1.725,0,0,0,124.034,190.7Z'
              transform='translate(-122.546 -188.841)'
              fill='#fff'
            />
          </g>
          <path
            id='Path_540'
            data-name='Path 540'
            d='M121.885,331.092a5.454,5.454,0,0,0-3.406,5.055v1h10.6v-1a5.454,5.454,0,0,0-3.406-5.055h-3.788Z'
            transform='translate(-110.713 -294.38)'
            fill='none'
          />
          <path
            id='Path_541'
            data-name='Path 541'
            d='M111.181,321.5h-6.8a.619.619,0,0,1-.619-.619v-.644a4.1,4.1,0,0,1,2.571-3.815.619.619,0,0,1,.232-.045H109a.618.618,0,0,1,.232.045,4.1,4.1,0,0,1,2.571,3.815v.644A.619.619,0,0,1,111.181,321.5ZM105,320.261h5.561v-.025a2.867,2.867,0,0,0-1.693-2.623h-2.176A2.867,2.867,0,0,0,105,320.235Z'
            transform='translate(-100.016 -282.692)'
            fill='#fff'
          />
        </g>
        <rect
          id='Rectangle_609'
          data-name='Rectangle 609'
          width='23'
          height='8'
          rx='3'
          transform='translate(36 246)'
          fill='#fff'
        />
      </g>
      <text
        id='REG123'
        transform='translate(38 247)'
        fill='#1f2b37'
        fontSize='5'
        fontFamily='Inter-Bold, Inter'
        fontWeight='700'
      >
        <tspan x='0' y='5'>
          REG123
        </tspan>
      </text>
    </g>
  </svg>,
  'GenerateReggieNumber'
)
